import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { SvgIcon } from '@valg-shared/utils/svg-icon';

let NEXT_ID = 0;

@Component({
  selector: 'valg-dk-search',
  styleUrls: [ './valgdk-search.component.scss' ],
  templateUrl: './valgdk-search.component.html'
})
export class ValgDKSearchComponent{

  @Output() search = new EventEmitter<string>();
  @Input() autoFocus = false;

  readonly SvgIcon = SvgIcon;
  public id: string = 'valg-search-' + NEXT_ID++;
  formGroup = new FormGroup({
    'query': new FormControl('')
  });

  performSearch() {
    let value = this.formGroup.controls['query'].value ?? "";
    this.search.emit(value);
  }

  public reset(){
    this.formGroup.controls['query'].setValue("");
    this.performSearch();
  }
}
